import {
    FEATURED_MATCHES_LAYOUT,
    UPCOMING_MATCHES_LAYOUT,
} from './constants';

export const getUpcomingMatchesLayoutKey = () => UPCOMING_MATCHES_LAYOUT;
export const getFeaturedMatchesLayoutKey = () => FEATURED_MATCHES_LAYOUT;

export const getWidgetDataUrl = (layout, sportSlug) => {
    if (layout === FEATURED_MATCHES_LAYOUT) {
        return `/sportsbook-req/getFeaturedMatchesEventsAjax/${sportSlug}`;
    }

    return `/sportsbook-req/getUpcomingMatchesEventsAjax/${sportSlug}`;
};
